<template>
  <div class="fillheight px-8 py-5">
    <div class="d-flex align-center flex-wrap">
      <div class="d-flex align-center">
        <v-avatar color="#E3FCF7" size="35">
          <v-icon color="#108F6E" size>mdi-folder</v-icon>
        </v-avatar>
        <div class="title-page pl-2">
          <v-breadcrumbs :items="breadcrumbs" class="pa-0">
            <template v-slot:divider>
              <v-icon>mdi-chevron-double-right</v-icon>
            </template>
          </v-breadcrumbs>
        </div>
      </div>

      <v-spacer></v-spacer>
      <div class="d-flex align-center flex-wrap">
        <!-- <base-button
          text
          @click.stop="onOpenMapDialog()"
          className="flexcol"
          :tooltip="`Thêm ${$t('sidebar.layer-group.name')}`"
        >
          <v-icon>mdi-map-plus</v-icon>
          <span v-if="!isMobile">
            Thêm {{ $t('sidebar.layer-group.name') }}
          </span>
        </base-button> -->
        <base-button
          text
          @click.stop="onOpenDatastoreDialog()"
          className="flexcol"
          :tooltip="`Thêm ${$t('sidebar.datastore.name')}`"
        >
          <v-icon>mdi-database-plus-outline</v-icon>
          <span v-if="!isMobile">Thêm {{ $t('sidebar.datastore.name') }}</span>
        </base-button>
        <base-button
          text
          @click.stop="onUpdateItem(workspace)"
          className="flexcol"
          :tooltip="`${$t('workspace.setting')}`"
          v-if="checkAccess('workspace.update', workspace)"
        >
          <v-icon>mdi-cog</v-icon>
          <span v-if="!isMobile">{{ $t('workspace.setting') }}</span>
        </base-button>
      </div>
    </div>

    <div class="d-flex align-center">
      <v-tabs centered grow>
        <!-- <v-tab exact key="map" :to="{ name: 'workspace.maps', params: { id } }">
          {{ $t('sidebar.layer-group.name') }}
        </v-tab> -->
        <v-tab
          exact
          key="layer"
          :to="{ name: 'workspace.layers', params: { id } }"
        >
          {{ $t('sidebar.layer.name') }}
        </v-tab>
        <v-tab
          exact
          key="dataStore"
          :to="{ name: 'workspace.datastores', params: { id } }"
        >
          {{ $t('datastore.name') }}
        </v-tab>
        <v-tab
          exact
          key="style"
          :to="{ name: 'workspace.styles', params: { id } }"
        >
          {{ $t('sidebar.style.name') }}
        </v-tab>
      </v-tabs>
    </div>
    <router-view
      @click:add-map="onOpenMapDialog"
      @click:add-datastore="onOpenDatastoreDialog"
      @click:add-layer="onOpenLayerDialog"
      ref="router"
      :workspace="workspace"
    ></router-view>
    <WorkspaceDialog ref="dialog" @reset="onReset" />
    <MapDetail ref="map_detail" :workspace_id="id" @reset="onResetMap" />
    <DatastoreDialog
      :workspace_id="id"
      ref="datastoredialog"
      @reset="onResetDatastore"
    />
    <LayerCreateDialog
      :workspace="[]"
      ref="layerdialog"
      @reset="onResetLayer"
    />
  </div>
</template>
<script>
import MapDetail from '@views/layer-group/layer-group-dialog.vue'
import LayerCreateDialog from '@views/layers/layer-create-dialog.vue'
import DatastoreDialog from '@views/datastores/datastore-dialog.vue'
import WorkspaceDialog from './workspace-dialog.vue'
import { API_WORKSPACE } from '@api'
import { EDIT_TYPE } from '@constant'
export default {
  components: {
    MapDetail,
    WorkspaceDialog,
    DatastoreDialog,
    LayerCreateDialog,
  },
  props: {
    id: [String, Number],
  },
  data: (vm) => ({
    workspace: null,
    breadcrumbs: [
      {
        text: vm.$t('workspace.all_workspace'),
        disabled: false,
        exact: true,
        to: { name: 'workspaces' },
      },
      {
        text: '',
        disabled: true,
      },
    ],
  }),
  created() {
    this.fetchData()
  },
  methods: {
    onReset() {
      this.fetchData()
    },
    onOpenMapDialog({ type, ...e } = {}) {
      this.$refs.map_detail.open(e || {}, type)
    },
    onOpenDatastoreDialog({ type, data } = {}) {
      this.$refs.datastoredialog.open(data, type)
    },
    onOpenLayerDialog({ type, data } = {}) {
      this.$refs.layerdialog.open(data, type)
    },
    onResetLayer() {
      if (this.$route.name != 'workspace.layers') {
        return
      }
      this.$refs.router.onReset()
    },
    onResetMap() {
      if (this.$route.name != 'workspace.maps') {
        return
      }
      this.$refs.router.onReset()
    },
    onResetDatastore() {
      if (this.$route.name != 'workspace.datastores') {
        return
      }
      this.$refs.router.onReset()
    },
    fetchData() {
      if (this.id) {
        API_WORKSPACE.getDetail(this.id).then((res) => {
          if (res.error) {
            this.$router.replace({ name: 'workspaces' })
          } else {
            this.workspace = res.data
            this.breadcrumbs[1].text = res.data.name
          }
        })
      }
    },
    onUpdateItem(item) {
      this.$refs.dialog.open(item, EDIT_TYPE.UPDATE)
    },
  },
}
</script>
